export const NAME = 'quote';